import { createReducer, on } from "@ngrx/store";

import { ContainerActions } from './containers.actions';

import { initialState, containersAdapter } from "./containers.state";
import { LoadingState } from "@core/models";


export const containersReducer = createReducer(
  initialState,

  on(ContainerActions.reset, (state) => ({ ...initialState })),

  on(ContainerActions.add, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ContainerActions.addSuccess, (state, { container }) => {
    return containersAdapter.upsertOne(container, { ...state, callState: LoadingState.LOADED });
  }),
  on(ContainerActions.addFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ContainerActions.update, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ContainerActions.updateSuccess, (state, { container }) => {
    return containersAdapter.upsertOne(container, { ...state, callState: LoadingState.LOADED });
  }),
  on(ContainerActions.updateFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ContainerActions.remove, (state, { id }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ContainerActions.removeSuccess, (state, { id }) => {
    return containersAdapter.removeOne(id, { ...state, callState: LoadingState.LOADED });
  }),
  on(ContainerActions.removeFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ContainerActions.load, (state) => ({
    ...state,
    // Only set LOADING on initial fetch so the list stays visible when refetching (merge behavior).
    callState: state.ids.length === 0 ? LoadingState.LOADING : state.callState,
  })),
  on(ContainerActions.loadSuccess, (state, { containers }) => {
    return containersAdapter.upsertMany(containers, { ...state, callState: LoadingState.LOADED });
  }),
  on(ContainerActions.loadFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),
);
